module.exports = __webpack_public_path__ + "static/media/DSC_0156.a921a2d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/animals/DSC_0156.jpg
// module id = 561
// module chunks = 0